<template>
    <div class="how-to-make-container">
        <div class="left-info">
            <div class="left-title">如何制作成实体手册</div>
            <div class="tip-title">1. 我需要准备什么？</div>
            <div class="tip-content">您需要选择本次制作产品手册的业务领域（建议先从最熟悉的业务开启制作），准备好律所Logo、团队简介和照片、以及成功案例等</div>
            <div class="tip-title">2.有参考范例么？</div>
            <div class="tip-content">您可以<a href="https://res.alphalawyer.cn/pluginInfo/live/%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C%E8%87%AA%E5%88%B6%E6%A8%A1%E6%9D%BF.docx">点击此处下载模板</a>，对文件内容进行修改，形成初稿</div>
            <div class="tip-title">3. 怎么对手册的设计美化？</div>
            <div class="tip-content">您可以<a href="https://res.alphalawyer.cn/pluginInfo/live/%E6%89%8B%E5%86%8C%E4%B8%8B%E8%BD%BD%E8%AE%BE%E8%AE%A1%E6%8C%87%E5%8D%97%E5%92%8C%E6%A8%A1%E7%89%88.zip">点击此处下载设计指南和模板</a>，按范例对手册进行设计美化，形成终稿</div>
        </div>
        <img src="@/assets/svg/prod-book.svg">
    </div>
</template>

<script>

    export default {
        name: "TemplateContainer",
        props: {tip: String, title: String, icon: String, contents: Array}
    }
</script>

<style scoped lang="scss">
    .how-to-make-container {
        color: #ED6C00;
        font-weight: 600;
        text-align: left;
        overflow: hidden;
        width: 727px;
        background: #FFFFFF;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        .left-info{
            width: 467px;
            height: 296px;
            padding: 22px 24px;
            float: left;
            .left-title,.tip-title{
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #444444;
                margin-bottom: 24px;
            }
            .tip-title{
                margin-bottom: 7px;
            }
            .tip-content{
                font-size: 12px;
                line-height: 17px;
                color: #8C8C8C;
                font-weight: normal;
                margin-bottom: 20px;
            }
            a{
                color: #8C8C8C;
                text-decoration: underline;
                &:hover{
                    color: #ED6C00;
                }
            }
        }
        img{
            height: 296px;
            display: block;
            float: right;
        }
    }
</style>